enum VAlign {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
}

enum VAlignCommand {
  TOP = 'vertical-align-top',
  MIDDLE = 'vertical-align-middle',
  BOTTOM = 'vertical-align-bottom',
}

export { VAlign, VAlignCommand }
